export const variables={
    // API_URL:"https://localhost:44317/",
    // API_AUTH:"https://localhost:44317/Auth/",
    // PHOTO_URL:"https://localhost:44317/Photos/"

    API_URL:"https://ticket.sanpad.ir/api/",
    API_AUTH:"https://ticket.sanpad.ir/api/Auth/",
    PHOTO_URL:"https://ticket.sanpad.ir/Photos/"

}